import routes from '@routes/config';

export default [{
    path: routes.bank.index,
    name: routes.bank.index,
    component: () => import(/* webpackChunkName: "Bank" */  '@components/Bank/Index')
}]
